import type { ToolTestRun } from '../../lib/api';
import styles from './ToolTestResult.module.css';
import { ToolTestSourceResponsePane } from './ToolTestSourceResponsePane';

interface ToolTestSourceResponseCardProps {
  sourceResponse: NonNullable<ToolTestRun['sourceResponse']>;
}

/** Shows the sanitized upstream response retained when result mapping fails. */
export const ToolTestSourceResponseCard = ({ sourceResponse }: ToolTestSourceResponseCardProps) => (
  <section className={styles.card}>
    <ToolTestSourceResponsePane sourceResponse={sourceResponse} />
  </section>
);
